export * from '@primeuix/themes/lara/avatar';
export { default } from '@primeuix/themes/lara/avatar';
